import { OUTLINE_DEFAULT_COLUMN_WIDTH } from "../../../constants";
import { OUTLINE_VIEW, SPREADSHEET_VIEW } from "../../../constants/identifiers";
import { DefaultColumnsRecord } from "../../../types/immutableRecords/model/definitions/DefaultColumnsRecord";
import { moveTableColumnInList, updateTableColumnList } from "../../../utils/tableColumns";
// Direct import from the appState actions
// to avoid importing loops from definitions -> defaultColumns -> appState -> ... -> definitions
import appStateActionTypes from "../../appState/actions";

const toggleColumn = (state, action, viewType, prevGlobalState) => {
  const defaultWidth = OUTLINE_DEFAULT_COLUMN_WIDTH;
  const result = state.updateIn([viewType], columns =>
    updateTableColumnList(columns, action.columnId, action.showColumn, defaultWidth, prevGlobalState)
  );
  return result;
};

const resizeColumn = (state, action, viewType, prevGlobalState) => {
  return state.updateIn([viewType], columns =>
    updateTableColumnList(columns, action.columnId, true, action.width, prevGlobalState)
  );
};

const moveColumn = (state, action, viewType, prevGlobalState) => {
  return state.updateIn([viewType], columns =>
    moveTableColumnInList(columns, action.columnId, action.index, prevGlobalState)
  );
};

const reducer = (state = DefaultColumnsRecord(), action, prevGlobalState) => {
  switch (action.type) {
    case appStateActionTypes.TOGGLE_SPREADSHEET_COLUMN:
      return toggleColumn(state, action, SPREADSHEET_VIEW, prevGlobalState);
    case appStateActionTypes.RESIZE_SPREADSHEET_COLUMN:
      return resizeColumn(state, action, SPREADSHEET_VIEW, prevGlobalState);
    case appStateActionTypes.MOVE_SPREADSHEET_COLUMN:
      return moveColumn(state, action, SPREADSHEET_VIEW, prevGlobalState);
    case appStateActionTypes.TOGGLE_OUTLINE_COLUMN:
      return toggleColumn(state, action, OUTLINE_VIEW, prevGlobalState);
    case appStateActionTypes.RESIZE_OUTLINE_COLUMN:
      return resizeColumn(state, action, OUTLINE_VIEW, prevGlobalState);
    case appStateActionTypes.MOVE_OUTLINE_COLUMN:
    default:
      return state;
  }
};

export default reducer;
